import React from 'react';

function AlertCircle({ size, ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      {...otherProps}
    >
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(-92.000000, -47.000000)">
          <g transform="translate(95.000000, 50.000000)">
            <circle stroke="#000000" strokeWidth="1.3" cx="9" cy="9" r="9" />
            <path d="M5,12 C7,14 11,14 13,12" stroke="#000000" strokeWidth="1.3" />
            <circle fill="#000000" cx="6" cy="6" r="1" />
            <circle fill="#000000" cx="12" cy="6" r="1" />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default AlertCircle;
